<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_REPORT_STOCK_ROUTE_LIST" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="false"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      :is-pagination="false"
      :stripe="true"
      is-list
      :span-method="spanMethod"
      :show-summary="showSummary"
      :summary-method="summaryMethod"
      :row-class-name="rowClassName"
      :default-sort="defaultSort"
      :reset-data="resetData"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      @sort-change="sortChange"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportStockDeliver.deliveryTime')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('BusinessReportStockDeliver.deliveryTime')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportStockDeliver.warehouseIds')" prop="warehouseIds">
            <BjSelectWarehouse v-model="queryParams.warehouseIds" :placeholder="$t('BusinessReportStockDeliver.warehouseIds')" :type-code="['logic']" multiple />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportStockDeliver.logisticsCompanyIds')" prop="logisticsCompanyIds">
            <BjSelectLogisticCompany v-model="queryParams.logisticsCompanyIds" :placeholder="$t('BusinessReportStockDeliver.logisticsCompanyIds')" multiple />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="colSpan">
          <el-form-item label="汇总方式" prop="statsType">
            <BjSelectLov
              v-model="queryParams.statsType"
              :option-list="collectTypeOptions"
              :clearable="false"
            />
          </el-form-item>
        </el-col> -->
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <BjRadioLov
            v-model="queryParams.statsType"
            :option-list="collectTypeOptions"
            :placeholder="$t('chooseText')"
          />
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <el-table-column
          v-if="queryParams.statsType === 1"
          :label="$t('BusinessReportStockDeliver.warehouseIds')"
          prop="warehouseName"
          align="center"
        ></el-table-column>
        <el-table-column :label="$t('BusinessReportStockDeliver.logisticsCompanyIds')" prop="logisticsCompanyName" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type">{{ $t('BusinessReportStockDeliver.subtotal') }}</span>
            <span v-else>{{ scope.row.logisticsCompanyName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('BusinessReportStockDeliver.shippingQty')" prop="shippingQty" align="center" sortable="custom">
          <!-- <template #header>
            发货单数
            <span class="caret-wrapper"
              ><i class="sort-caret ascending"></i><i class="sort-caret descending"></i
            ></span>
          </template> -->
        </el-table-column>
        <el-table-column
          :label="$t('BusinessReportStockDeliver.packageQty')"
          prop="packageQty"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          :label="$t('BusinessReportStockDeliver.goodsQty')"
          prop="goodsQty"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          :label="$t('BusinessReportStockDeliver.postageTotal')"
          prop="postageTotal"
          align="center"
          sortable="custom"
        ></el-table-column>
        <!-- <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            :sortable="['goodsQuantity'].includes(col.prop)"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'logisticsCompanyName'">
                <span v-if="scope.row.type">小计</span>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template> -->
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
import { BUSINESS_REPORT_STOCK_ROUTE_LIST } from '@/utils/constants';
// 发货时间默认月初的第一天的00::00:00到月末的最后一天23:59:59
// 获取当月第一天和最后一天
const defaultTime = () => {
  const year = new Date().getFullYear();
  const month = new Date().getMonth() + 1;
  const startTime =
    year + '-' + month + '-' + '0' + new Date(year, month, 1).getDate() + ' 00:00:00';
  const endTime = year + '-' + month + '-' + new Date(year, month, 0).getDate() + ' 23:59:59';
  return [startTime, endTime];
};
// import dataJson from './data';
export default {
  name: 'BusinessReportStockDeliverIndex',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      selection: false,
      showSummary: false,
      BUSINESS_REPORT_STOCK_ROUTE_LIST,
      collectTypeOptions: [
        { label: this.$t('BusinessReportStockDeliver.collectTypeOptions1'), value: 1 },
        { label: this.$t('BusinessReportStockDeliver.collectTypeOptions2'), value: 2 },
      ],
      /** */
      queryApi: stockApi.getReportLogisticsResult,
      // 查询参数
      queryParamsTime: defaultTime(),
      // 已核对字段
      queryParams: {
        beginDate: null,
        endDate: null,
        channelTypeCode: null,
        warehouseIds: [],
        logisticsCompanyIds: [],
        statsType: 1,
      },
      labelsVersion: 11,
      labelList: [
        {
          label: this.$t('BusinessReportStockDeliver.warehouseIds'),
          prop: 'warehouseName',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportStockDeliver.logisticsCompanyIds'),
          prop: 'logisticsCompanyName',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportStockDeliver.shippingQty'),
          prop: 'shippingQty',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportStockDeliver.packageQty'),
          prop: 'packageQty',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportStockDeliver.goodsQty'),
          prop: 'goodsQty',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportStockDeliver.postageTotal'),
          prop: 'postageTotal',
          isCheck: true,
          disabled: false,
        },
      ],
      setData: null,
      cellList: [],
      count: null,
      // { prop: 'shippingQty', order: 'ascending' }
      defaultSort: { prop: '', order: '' },
    };
  },
  computed: {},
  watch: {
    queryParamsTime: {
      handler(v) {
        this.queryParams.beginDate = (v || [])[0];
        this.queryParams.endDate = (v || [])[1];
      },
      immediate: true,
    },
    'queryParams.statsType': {
      handler(v) {
        this.reFresh();
        this.defaultSort = {};
      },
    },
  },
  mounted() {},
  methods: {
    // 主表查询API
    // parentQueryApi(queryParams) {
    //   return new Promise(resolve => {
    //     resolve(dataJson);
    //   });
    // },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = defaultTime();
      return new Promise(resolve => {
        resolve();
      });
    },
    resetData(data) {
      // 判断是否显示合计
      this.showSummary = data.length > 1;
      // 1.数据整理（按仓库分组）
      this.setData = new Set();
      data.forEach(e => {
        this.setData.add(e.warehouseName);
      });
      let newTableData = [];
      // 2.计算小计

      this.setData.forEach(e => {
        const list = data.filter(name => name.warehouseName === e);
        if (this.queryParams.statsType === 1) {
          // 计算仓库数据总和（小计）
          list.push({
            shippingQty: totalFn(list, 'shippingQty'),
            packageQty: totalFn(list, 'packageQty'),
            goodsQty: totalFn(list, 'goodsQty'),
            postageTotal: totalFn(list, 'postageTotal'),
            warehouseName: e,
            type: 1, // 小计数据判断依据
          });
        }
        newTableData = newTableData.concat(list);
      });
      // 3.获取合并列数据
      this.setMergeData(newTableData);
      return newTableData;
      // 计算小计（只在函数调用）
      function totalFn(list, key) {
        let total = 0;
        list.forEach(e => {
          total += Number(e[key]);
        });
        return total;
      }
    },
    // 设置合并需要的数据
    setMergeData(tableData) {
      this.cellList = [];
      this.count = null;
      tableData.forEach((item, index) => {
        if (index === 0) {
          // 先设置第一项
          // 初为1，若下一项和此项相同，就往cellList数组中追加0
          this.cellList.push(1);
          this.count = 0; // 初始计数为0
        } else {
          // 判断当前项与上项的仓库是否相同，因为是合并这一列的单元格
          if (tableData[index].warehouseName == tableData[index - 1].warehouseName) {
            // 如果相等
            this.cellList[this.count] += 1;
            this.cellList.push(0); // 相等就往cellList数组中追加0
          } else {
            this.cellList.push(1); // 不等就往cellList数组中追加1
            this.count = index; // 将索引赋值为计数
          }
        }
      });
    },
    // 合并列
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.queryParams.statsType === 1) {
        // 给第一列做单元格合并。
        if (columnIndex === 0) {
          const rowCell = this.cellList[rowIndex];
          if (rowCell > 0) {
            const colCell = 1;
            return {
              rowspan: rowCell,
              colspan: colCell,
            };
          } else {
            // 清除原有的单元格，必须要加，否则就会出现单元格会被横着挤到后面
            // 数据若是动态后端获取的，就会出现
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
    rowClassName({ row, rowIndex }) {
      if (row.type) {
        return 'total';
      }
      return '';
    },
    /** 自定义排序 */
    sortChange({ column, prop, order }) {
      this.defaultSort = { prop: prop, order: order };
      const DATA = this.$lodash.clone(this.$refs.BjPage.tableData);
      let totalList = [];
      // 判断不同的汇总方式下的排序方式
      if (this.queryParams.statsType === 1) {
        // 获取排序好的小计数组
        totalList = DATA.filter(e => e.type);
        totalList = dataSort(totalList);
        this.setData.forEach(name => {
          let list = DATA.filter(item => item.warehouseName === name && !item.type);
          // 1.数据排序
          list = dataSort(list);
          // 2.组合数据（将内层排序添加到小计数据前）
          const index = totalList.findIndex(e => e.warehouseName === name);
          totalList.splice(index, 0, ...list);
          // 3.重新计算合并数据
          this.setMergeData(totalList);
        });
      } else {
        // 按物流商排序（直接对原数组进行排序）
        totalList = dataSort(DATA);
      }
      this.$refs.BjPage.tableData = totalList;
      function dataSort(arr) {
        if (order === 'ascending') {
          // 升序
          arr = arr.sort((a, b) => a[prop] - b[prop]);
        }
        if (order === 'descending') {
          // 降序
          arr = arr.sort((a, b) => b[prop] - a[prop]);
        }
        return arr;
      }
    },
    /** 自定义总合计 */
    summaryMethod({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('BusinessReportStockDeliver.total');
          return;
        }
        const values = data.filter(e => !e.type).map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table__body tr.total td.el-table__cell {
  background-color: $background-dis !important;
}
::v-deep .cell {
  cursor: pointer;
}
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
